module.exports = __webpack_public_path__ + "img/59.f5c61c1b.jpg";